enum ESpecialOffer {
  FLOW = 'flow',
  SMS = 'sms',
}

export {ESpecialOffer};
